import { AccountModel } from 'data-ng-authentication';
import { IUrlMatcher } from 'angular-ui-router';
import * as _4 from 'lodash4';
import { ICommand } from 'core-ts-types';

export class DeeplinksStateConfiguration implements ng.IServiceProvider {
  REDIRECT_URL_KEY = 'sgdRedirectUrl';
  constructor(private $stateProvider: ng.ui.IStateProvider, private $urlRouterProvider: ng.ui.IUrlRouterProvider) {}

  state(stateConfiguration: any): void {
    stateConfiguration = stateConfiguration || {};

    this.$stateProvider.state(
      'deeplink',
      _4.merge(
        {
          url: '/dl/:page/:firstParam/:secondParam/:thirdParam',
          controller: 'DeeplinkController',
          controllerAs: 'dl',
          data: {
            page: undefined,
            firstParam: undefined,
            secondParam: undefined,
            thirdParam: undefined
          },
          resolve: {
            accountModelData: (accountModel: AccountModel, loadAccountCommand: ICommand) => {
              const redirectUrl = localStorage.getItem(this.REDIRECT_URL_KEY);
              if (redirectUrl && redirectUrl.indexOf('#/dl/') === -1) {
                localStorage.setItem(this.REDIRECT_URL_KEY, window.location.href);
              }
              if (_4.isEmpty(accountModel.student_nk)) {
                return loadAccountCommand();
              }

              return true;
            },
            redirectToTos: (
              accountModel: AccountModel,
              accountModelData: unknown,
              $state: ng.ui.IStateService,
              $timeout: ng.ITimeoutService,
              $q: ng.IQService
            ) => {
              const willRedirectHasAcceptedTerms = _4.get(accountModel, 'acceptedTerms', true);
              const shouldLoadTOS = !willRedirectHasAcceptedTerms;
              const deferred = $q.defer();
              if (shouldLoadTOS) {
                localStorage.setItem(this.REDIRECT_URL_KEY, location.href);
                $timeout(() => {
                  $state.go(`tos`);
                }, 10);

                return deferred.reject();
              }

              return deferred.resolve();
            }
          }
        },
        stateConfiguration['deeplink']
      )
    );
  }

  enableDesktopURLNormalization(): void {
    const DEEPLINK_ROUTE_REGEX: RegExp = /\/dl[\/*\w\d]*/;
    this.$urlRouterProvider.when(DEEPLINK_ROUTE_REGEX, this.__normalizeUrls);
  }

  private __normalizeUrls(
    $state: ng.ui.IStateService,
    $match: RegExpMatchArray,
    $stateParams: ng.ui.IStateParamsService
  ): void {
    let routeArray = $match.input!.split('/');

    /*
     * routeArray[0] is empty, it is the leading slash in the URL
     * routeArray[1] is the string 'dl', we don't care about that
     */
    let stateParams = {
      page: routeArray[2],
      firstParam: _4.isEmpty(routeArray[3]) ? undefined : routeArray[3],
      secondParam: _4.isEmpty(routeArray[4]) ? undefined : routeArray[4],
      thirdParam: _4.isEmpty(routeArray[5]) ? undefined : routeArray[5]
    };
    $state.go('deeplink', stateParams);
  }

  $get(): this {
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-deeplink/src/config/deeplink_state_config.ts